export const maxNameLength = 25;
export const maxSpecialRequestsLength = 250;
export const maxMessageLength = 2000;
export const maxEmailLength = 30;
export const maxPhoneLength = 15;
